import { render } from "./airTransport.vue?vue&type=template&id=74e02043&scoped=true"
import script from "./airTransport.vue?vue&type=script&lang=js"
export * from "./airTransport.vue?vue&type=script&lang=js"

import "./airTransport.vue?vue&type=style&index=0&id=74e02043&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e02043"]])

export default __exports__